module.exports = __webpack_public_path__ + "img/app10.16e47b86.png";